import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import jenkinsPlugin from '@backstage-community/plugin-jenkins/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import confluencePlugin from '@backstage-community/plugin-confluence/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { navModule } from './modules/nav';
import { catalogGraphModule } from './modules/catalogGraph';
import { mongoDbAtlasModule } from './modules/mongodbAtlas';
import { redisCloudModule } from './modules/redisCloud';
import { confluentCloudModule } from './modules/confluentCloud';
import { elasticCloudModule } from './modules/elasticCloud';
import { grafanaModule } from './modules/grafana';
import { serviceInstrumentationModule } from './modules/serviceInstrumentation';
import { argoRolloutsModule } from './modules/argoRollouts';
import { gcpUptimePlugin } from './modules/gcpUptime';
import { gcpLoadBalancerModule } from './modules/gcpLoadBalancer';
import { gcpInstanceGroupModule } from './modules/gcpInstanceGroup';
import { kubernetesLiveLogsModule } from './modules/kubernetesLiveLogs';

const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => {
          const { ApnaSignInPage } = await import(
            './modules/auth/ApnaSignInPage'
          );
          return props => <ApnaSignInPage {...props} />;
        },
      },
    }),
  ],
});
export default createApp({
  features: [
    catalogPlugin,
    catalogGraphPlugin,
    jenkinsPlugin,
    kubernetesPlugin,
    confluencePlugin,
    grafanaPlugin,
    navModule,
    catalogGraphModule,
    mongoDbAtlasModule,
    redisCloudModule,
    confluentCloudModule,
    elasticCloudModule,
    argoRolloutsModule,
    grafanaModule,
    serviceInstrumentationModule,
    gcpUptimePlugin,
    gcpLoadBalancerModule,
    gcpInstanceGroupModule,
    kubernetesLiveLogsModule,
    authModule,
  ],
});
